import React from 'react';
import dayjs from 'dayjs';
import tickIcon from "../../../assets/icon/tick.png";
import cancelIcon from "../../../assets/icon/cancel.png";

export const ShipperTableDesktop = ({
    data,
    sumaryCuisine,
    headCellsSendToShipper,
    handleRequestSort,
    order,
    orderBy,
    GetSumaryDelivery,
    searchData,
    handleDetailClick,
    setOpenActiveDialog,
    openConfirmDialog,
    DataTableSarang
}) => {
    return (
        <DataTableSarang
            sumary={sumaryCuisine}
            headCells={headCellsSendToShipper}
            handleRequestSort={handleRequestSort}
            order={order}
            orderBy={orderBy}
            getSumary={GetSumaryDelivery}
            searchData={searchData}
        >
            <tbody>
                {data.length > 0 ? (
                    data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            <td style={{ cursor: 'pointer' }} onClick={(event) => handleDetailClick(event, row)}>
                                <span className={row.receiptTime === 1 ? "text-success" : (row.receiptTime === 2 ? "text-primary" : "text-danger")}>
                                    {dayjs(row.deliveryDate).format("DD/MM/YYYY")}
                                </span>
                            </td>
                            <td style={{ cursor: 'pointer' }} onClick={(event) => handleDetailClick(event, row)}>
                                <span className={row.receiptTime === 1 ? "text-success" : (row.receiptTime === 2 ? "text-primary" : "text-danger")}>
                                    {row.receiptTime === 1 ? "Sáng" : (row.receiptTime === 2 ? "Trưa" : "Chiều")}
                                </span>
                            </td>
                            <td style={{ cursor: 'pointer' }} onClick={(event) => handleDetailClick(event, row)}>
                                <span>{row.herdsmanDeliveryName}</span>
                                {row.herdsmanDeliveryPhone && (
                                    <span>&nbsp;(<a href={`tel:${row.herdsmanDeliveryPhone}`}>{row.herdsmanDeliveryPhone}</a>)</span>
                                )}
                            </td>
                            <td style={{ cursor: 'pointer' }} onClick={(event) => handleDetailClick(event, row)}>
                                <span>{row.quantity}</span>
                            </td>
                            <td>
                                <span>{row.transportStatusName}</span>&nbsp;&nbsp;
                                <span>
                                    {row.transportStatus >= 50 ? (
                                        <img title="Đã giao Shipper" src={tickIcon} alt="Tick" />
                                    ) : (
                                        <img
                                            title="Chưa giao Shipper, bấm để xác nhận giao"
                                            style={{ cursor: 'pointer' }}
                                            src={cancelIcon}
                                            alt="Cancel"
                                            onClick={() => {
                                                setOpenActiveDialog(true);
                                                openConfirmDialog(row);
                                            }}
                                        />
                                    )}
                                </span>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr><td colSpan={10}>Chưa có dữ liệu</td></tr>
                )}
            </tbody>
        </DataTableSarang>
    );
};

export const ShipperTableMobile = ({
    data,
    headCellsSendToShipper,
    GetSumaryDelivery,
    searchData,
    setOrder,
    setOrderBy,
    handleDetailClick,
    setOpenActiveDialog,
    openConfirmDialog,
    MobileHeaderSarang
}) => {
    return (
        <div className="accrodion-regular">
            <MobileHeaderSarang
                headCell={headCellsSendToShipper}
                handleSortChange={() => GetSumaryDelivery(searchData)}
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                getSumary={GetSumaryDelivery}
                searchData={searchData}
            />
            <div id="accordion">
                {data.length > 0 ? (
                    data.map((item, index) => (
                        <div className="card" key={index}>
                            <div className="d-flex align-items-center" id={`heading-${item.id}`}>
                                <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }}
                                    data-toggle="collapse" data-target={`#collapse-${item.id}`} aria-expanded="false" aria-controls={`collapse-${item.id}`}>
                                    <div className="d-flex">
                                        <h4 className={"mb-1 " + (item.receiptTime === 1 ? "text-success" : (item.receiptTime === 2 ? "text-primary" : "text-danger"))}>
                                            {item.receiptTime === 1 ? "Sáng" : (item.receiptTime === 2 ? "Trưa" : "Chiều")}&nbsp;
                                            {dayjs(item.deliveryDate).format("DD/MM/YYYY")}
                                        </h4>
                                    </div>
                                    <div className='row'>
                                        <div className='col-6'>
                                            <div className='mt-0'><b>Ace Shipper: </b>
                                                <span>{item.herdsmanDeliveryName}</span>
                                                {item.herdsmanDeliveryPhone && (
                                                    <span>&nbsp;(<a href={`tel:${item.herdsmanDeliveryPhone}`}>{item.herdsmanDeliveryPhone}</a>)</span>
                                                )}
                                            </div>
                                            <div className='mt-0'><b>Số lượng: </b>
                                                <span>{item.quantity}</span>
                                                <button className="d-inline-block btn btn-xs btn-outline-success" data-toggle="tooltip" data-placement="top"
                                                    title="Xem chi tiết"
                                                    onClick={(event) => handleDetailClick(event, item)}
                                                >
                                                    <i className="fas fa-list-alt"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className='col-6'>
                                            <div className='mt-2'><b>Trạng Thái: </b> {item.transportStatusName}</div>
                                            <div className='mt-0'>
                                                {item.transportStatus >= 50 ? (
                                                    <img title="Đã giao Shipper" src={tickIcon} alt="Tick" />
                                                ) : (
                                                    <img
                                                        title="Chưa giao Shipper"
                                                        style={{ cursor: 'pointer' }}
                                                        src={cancelIcon}
                                                        alt="Cancel"
                                                        onClick={() => {
                                                            setOpenActiveDialog(true);
                                                            openConfirmDialog(item);
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="card">Chưa có dữ liệu</div>
                )}
            </div>
        </div>
    );
};
